var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "orders-list-table" },
    [
      _c(
        "el-table",
        {
          ref: "multipleTable",
          attrs: { data: _vm.dataList },
          on: { "selection-change": _vm.onSelectionChange },
        },
        [
          _vm._l(
            _vm.config,
            function ({ type, prop, label, width, slot, align, fixed }) {
              return [
                type
                  ? _c("el-table-column", {
                      key: prop,
                      attrs: {
                        label: label,
                        type: type,
                        "min-width": width,
                        align: align,
                      },
                    })
                  : slot
                  ? _c("el-table-column", {
                      key: prop,
                      attrs: {
                        prop: prop,
                        label: label,
                        "min-width": width,
                        fixed: fixed,
                        align: align,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                slot === "no"
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "itemN",
                                          style: { zIndex: 100 - scope.$index },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticStyle: { display: "flex" },
                                            },
                                            [
                                              scope.row.orderInfo
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "margin-left": "40px",
                                                        cursor: "pointer",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.copyInfo(
                                                            scope.row.orderInfo
                                                              .orderNo
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " 订单编号：" +
                                                          _vm._s(
                                                            scope.row.orderInfo
                                                              .orderNo
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "div",
                                                { staticClass: "hint_pr" },
                                                [
                                                  _vm._v(
                                                    " 创建时间：" +
                                                      _vm._s(
                                                        scope.row.orderInfo
                                                          .createdTime
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "hint_pr" },
                                                [
                                                  _vm._v(
                                                    " 支付时间：" +
                                                      _vm._s(
                                                        scope.row.orderInfo
                                                          .payTime
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "hint_pr",
                                                  staticStyle: {
                                                    cursor: "pointer",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.copyInfo(
                                                        scope.row.orderInfo
                                                          .outTradeNo
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    " 支付单号：" +
                                                      _vm._s(
                                                        scope.row.orderInfo
                                                          .outTradeNo
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "hint_pr" },
                                                [
                                                  _vm._v(
                                                    " 订单类型：" +
                                                      _vm._s(
                                                        scope.row.orderInfo
                                                          .orderTypeLabel
                                                      ) +
                                                      " "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "hint_pr-operation",
                                              staticStyle: {
                                                "margin-right": "50px",
                                              },
                                            },
                                            [
                                              [
                                                _c(
                                                  "el-dropdown",
                                                  {
                                                    attrs: {
                                                      placement: "bottom",
                                                    },
                                                    on: {
                                                      command: function (
                                                        $event
                                                      ) {
                                                        return _vm.handleCommand(
                                                          $event,
                                                          scope.row
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "el-dropdown-link",
                                                        staticStyle: {
                                                          color: "#4168e7",
                                                          cursor: "pointer",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(" 更多"),
                                                        _c("i", {
                                                          staticClass:
                                                            "el-icon-arrow-down el-icon--right",
                                                          staticStyle: {
                                                            color: "#4168e7",
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                    _c(
                                                      "el-dropdown-menu",
                                                      {
                                                        attrs: {
                                                          slot: "dropdown",
                                                        },
                                                        slot: "dropdown",
                                                      },
                                                      [
                                                        _c(
                                                          "el-dropdown-item",
                                                          {
                                                            attrs: {
                                                              command: "1",
                                                            },
                                                          },
                                                          [_vm._v("查看")]
                                                        ),
                                                        scope.row.status == 1
                                                          ? _c(
                                                              "el-dropdown-item",
                                                              {
                                                                attrs: {
                                                                  command: "2",
                                                                },
                                                              },
                                                              [_vm._v("审核")]
                                                            )
                                                          : _vm._e(),
                                                        scope.row.status == 5
                                                          ? _c(
                                                              "el-dropdown-item",
                                                              {
                                                                attrs: {
                                                                  command: "3",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "换货寄出"
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        scope.row.status == 6
                                                          ? _c(
                                                              "el-dropdown-item",
                                                              {
                                                                attrs: {
                                                                  command: "4",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "修改换货单号"
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        scope.row.status == 3
                                                          ? _c(
                                                              "el-dropdown-item",
                                                              {
                                                                attrs: {
                                                                  command: "5",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "退货单号"
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        scope.row.status == 4
                                                          ? _c(
                                                              "el-dropdown-item",
                                                              {
                                                                attrs: {
                                                                  command: "6",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "修改退货单号"
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        scope.row.status == 4
                                                          ? _c(
                                                              "el-dropdown-item",
                                                              {
                                                                attrs: {
                                                                  command: "7",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "查看退货物流"
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        scope.row.status == 6
                                                          ? _c(
                                                              "el-dropdown-item",
                                                              {
                                                                attrs: {
                                                                  command: "8",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "查看换货物流"
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        scope.row.status == 6
                                                          ? _c(
                                                              "el-dropdown-item",
                                                              {
                                                                attrs: {
                                                                  command: "9",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "确认收货"
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        scope.row.status == 4
                                                          ? _c(
                                                              "el-dropdown-item",
                                                              {
                                                                attrs: {
                                                                  command: "10",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "确认收货"
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                            ],
                                            2
                                          ),
                                        ]
                                      ),
                                      _c("div", [
                                        _vm._v(_vm._s(scope.row.afterNo)),
                                      ]),
                                    ]
                                  : _vm._e(),
                                slot === "info"
                                  ? [
                                      scope.row.orderAfterDetailList
                                        ? _c(
                                            "div",
                                            _vm._l(
                                              scope.row.orderAfterDetailList,
                                              function (item, index) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: index,
                                                    staticClass: "mesSty",
                                                  },
                                                  [
                                                    _c("el-image", {
                                                      attrs: {
                                                        src: item.goodsImg,
                                                        fit: "cover",
                                                      },
                                                    }),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "mesFont",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              width: "100%",
                                                              display:
                                                                "-webkit-box",
                                                              "-webkit-box-orient":
                                                                "vertical",
                                                              "-webkit-line-clamp":
                                                                "2",
                                                              "text-overflow":
                                                                "ellipsis",
                                                              overflow:
                                                                "hidden",
                                                              "margin-left":
                                                                "8px",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  item.goodsName
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticStyle: {
                                                              width: "100%",
                                                              display:
                                                                "-webkit-box",
                                                              "-webkit-box-orient":
                                                                "vertical",
                                                              "-webkit-line-clamp":
                                                                "1",
                                                              "text-overflow":
                                                                "ellipsis",
                                                              overflow:
                                                                "hidden",
                                                              "margin-left":
                                                                "8px",
                                                              "font-size":
                                                                "13px",
                                                              "font-family":
                                                                "Microsoft YaHei",
                                                              "font-weight":
                                                                "400",
                                                              "line-height":
                                                                "17px",
                                                              color: "#606066",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " 规格：" +
                                                                _vm._s(
                                                                  item.goodsSkuName
                                                                ) +
                                                                " * " +
                                                                _vm._s(
                                                                  item.afterQuantity
                                                                ) +
                                                                " "
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _vm._e(),
                                    ]
                                  : _vm._e(),
                                slot === "user"
                                  ? [
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(scope.row.orderInfo.userName)
                                        ),
                                      ]),
                                      _c("p", [
                                        _vm._v(
                                          "ID:" +
                                            _vm._s(scope.row.orderInfo.userId)
                                        ),
                                      ]),
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(scope.row.orderInfo.userPhone)
                                        ),
                                      ]),
                                    ]
                                  : _vm._e(),
                                slot === "post"
                                  ? [
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(scope.row.orderInfo.postName)
                                        ),
                                      ]),
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(scope.row.orderInfo.postPhone)
                                        ),
                                      ]),
                                    ]
                                  : _vm._e(),
                                slot === "address"
                                  ? [
                                      _c(
                                        "p",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "flex-wrap": "wrap",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.orderInfo
                                                .postDistrictAddress
                                            ) +
                                              _vm._s(
                                                scope.row.orderInfo.postAddress
                                              )
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                                slot === "miniAppName"
                                  ? [
                                      _c(
                                        "p",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "flex-wrap": "wrap",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.orderInfo.miniAppName
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                                slot === "refundMoney"
                                  ? [
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(
                                            Number(
                                              scope.row.refundMoney
                                            ).toFixed(2)
                                          )
                                        ),
                                      ]),
                                    ]
                                  : _vm._e(),
                                slot === "status"
                                  ? [
                                      _c(
                                        "p",
                                        {
                                          attrs: {
                                            title: scope.row.statusLabel,
                                          },
                                        },
                                        [
                                          _c("i", {
                                            class: [
                                              {
                                                "danger-bg":
                                                  scope.row.status == 2,
                                              },
                                              {
                                                "info-bg":
                                                  scope.row.status == 7,
                                              },
                                              {
                                                "warning-bg":
                                                  scope.row.status == 1 ||
                                                  scope.row.status == 3 ||
                                                  scope.row.status == 4 ||
                                                  scope.row.status == 5 ||
                                                  scope.row.status == 6,
                                              },
                                              "round",
                                              {
                                                "success-bg":
                                                  scope.row.status === 8,
                                              },
                                            ],
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(scope.row.statusLabel) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                                slot === "approveRemark"
                                  ? [
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.approveRemark || "--"
                                          )
                                        ),
                                      ]),
                                    ]
                                  : _vm._e(),
                              ]
                            },
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  : _c("el-table-column", {
                      key: prop,
                      attrs: {
                        prop: prop,
                        label: label,
                        "min-width": width,
                        align: align,
                      },
                    }),
              ]
            }
          ),
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "售后申请",
            visible: _vm.isApply,
            width: "40%",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isApply = $event
            },
          },
        },
        [
          [
            _c("div", { staticClass: "info" }, [_vm._v("是否审核通过？")]),
            _c(
              "div",
              { staticStyle: { "margin-top": "18px" } },
              [
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.status,
                      callback: function ($$v) {
                        _vm.status = $$v
                      },
                      expression: "status",
                    },
                  },
                  [
                    _c("el-radio", { attrs: { label: 1 } }, [_vm._v("通过")]),
                    _c("el-radio", { attrs: { label: 2 } }, [_vm._v("驳回")]),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.status == 1 && _vm.afterType == 0
              ? _c("div", { staticClass: "pass" }, [
                  _vm._v(" 确认后，金额"),
                  _c("span", { staticClass: "price" }, [
                    _vm._v("￥" + _vm._s(_vm.refundMoney)),
                  ]),
                  _vm._v("将退回买家账户 "),
                ])
              : _vm._e(),
            _vm.status == 1 && _vm.afterType != 0
              ? _c(
                  "div",
                  {
                    staticClass: "sTable",
                    staticStyle: { "margin-top": "10px" },
                  },
                  [
                    _vm.status == 1
                      ? _c(
                          "el-table",
                          {
                            attrs: { data: _vm.gridData, border: "" },
                            on: { "row-click": _vm.rowClick },
                          },
                          [
                            _c("el-table-column", {
                              attrs: { prop: "select", width: "50" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-radio",
                                          {
                                            attrs: { label: scope.row.id },
                                            model: {
                                              value: _vm.radioIdSelect,
                                              callback: function ($$v) {
                                                _vm.radioIdSelect = $$v
                                              },
                                              expression: "radioIdSelect",
                                            },
                                          },
                                          [_vm._v(" ")]
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3374867373
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "name",
                                label: "收货人姓名",
                                width: "200",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                prop: "phone",
                                label: "收货人电话",
                                width: "200",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: { prop: "address", label: "收货地址" },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm.status == 2
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-top": "24px",
                      width: "100%",
                      "margin-bottom": "24px",
                    },
                  },
                  [
                    _c("div", { staticStyle: { display: "flex" } }, [
                      _c(
                        "div",
                        {
                          staticStyle: { "margin-right": "8px", width: "10%" },
                        },
                        [_vm._v("备注")]
                      ),
                      _c(
                        "div",
                        { staticStyle: { width: "100%" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              type: "textarea",
                              placeholder: "请输入备注",
                              maxlength: "200",
                              "show-word-limit": "",
                              rows: "5",
                            },
                            model: {
                              value: _vm.remark,
                              callback: function ($$v) {
                                _vm.remark = $$v
                              },
                              expression: "remark",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "end",
                  "margin-top": "24px",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "info-q",
                    on: {
                      click: function ($event) {
                        _vm.isApply = false
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
                _c(
                  "div",
                  {
                    staticClass: "info-s",
                    on: {
                      click: function ($event) {
                        return _vm.submitApply()
                      },
                    },
                  },
                  [_vm._v("确定")]
                ),
              ]
            ),
          ],
        ],
        2
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "温馨提示",
            visible: _vm.isInfo,
            width: "518px",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isInfo = $event
            },
          },
        },
        [
          [
            _c("div", { staticStyle: { "font-size": "20px" } }, [
              _vm._v("是否确认收货?"),
            ]),
            this.typeI == "user"
              ? _c("div", [
                  _vm._v(" 请确认平台用户是否收货，该操作不可修改！ "),
                ])
              : _c("div", [_vm._v("请确认仓库收货，该操作不可修改！")]),
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "justify-content": "end",
                  "margin-top": "24px",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "info-q",
                    on: {
                      click: function ($event) {
                        _vm.isInfo = false
                      },
                    },
                  },
                  [_vm._v("取消")]
                ),
                _c(
                  "div",
                  { staticClass: "info-s", on: { click: _vm.submitInfo } },
                  [_vm._v("确定")]
                ),
              ]
            ),
          ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }